@if (values) {
  <dl class="row">
    <dt class="col-sm-1">{{ label }}:</dt>
    <dd class="col-sm-11">
      {{ values }}
    </dd>
  </dl>
}
